module.exports = __webpack_public_path__ + "static/media/nextjs.a95348e2.svg";